(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rostic-cos-optiuni"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rostic-cos-optiuni')) {
    class RosticCosOptiuni extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.laSchimbare);
        this.addEventListener('input', this.laIntroducere);
        this.addEventListener('invalid', this.laInvalid, true);
        this.actualizeazaCampuri();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.laSchimbare);
        this.removeEventListener('input', this.laIntroducere);
        this.removeEventListener('invalid', this.laInvalid, true);
      }

      get comutator() {
        return this.querySelector('.rostic-cos__comutator');
      }

      // Câmpurile de firmă sunt obligatorii doar cu comutatorul pornit; oprite, nu pleacă spre checkout.
      actualizeazaCampuri() {
        const activ = Boolean(this.comutator && this.comutator.checked);
        this.querySelectorAll('.rostic-cos__campuri input').forEach((camp) => {
          camp.disabled = !activ;
          camp.required = activ && camp.hasAttribute('data-obligatoriu');
        });
      }

      laSchimbare = (event) => {
        const camp = event.target;
        if (!(camp instanceof HTMLInputElement) || !camp.name.startsWith('attributes[')) return;
        if (camp === this.comutator) this.actualizeazaCampuri();
        this.salveaza();
      };

      laIntroducere = (event) => {
        if (event.target instanceof HTMLInputElement) event.target.setCustomValidity('');
      };

      laInvalid = (event) => {
        const camp = event.target;
        if (camp instanceof HTMLInputElement && camp.dataset.eroare) camp.setCustomValidity(camp.dataset.eroare);
      };

      salveaza() {
        const atribute = {};
        this.querySelectorAll('input[name^="attributes["]:not([type="hidden"])').forEach((camp) => {
          const cheie = camp.name.slice('attributes['.length, -1);
          if (camp.type === 'checkbox') {
            atribute[cheie] = camp.checked ? camp.value : '';
          } else {
            atribute[cheie] = camp.disabled ? '' : camp.value.trim();
          }
        });

        const radacina = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(`${radacina}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: atribute }),
        }).catch(() => {
          // Atributele pleacă oricum cu formularul coșului, la trecerea spre checkout.
        });
      }
    }

    customElements.define('rostic-cos-optiuni', RosticCosOptiuni);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rostic-estimare"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rostic-livrare-estimare')) {
    class RosticLivrareEstimare extends HTMLElement {
      connectedCallback() {
        // Rezultatul stă în shadow DOM: când Horizon reîmprospătează coșul sau varianta, actualizează doar textul
        // de rezervă din elementul obișnuit, iar intervalul calculat rămâne afișat.
        if (this.shadowRoot) return;
        try {
          const text = this.calculeaza();
          this.attachShadow({ mode: 'open' }).textContent = text;
        } catch (eroare) {
          // Rămâne textul de rezervă generat pe server.
        }
      }

      calculeaza() {
        const min = parseInt(this.dataset.min, 10);
        const max = parseInt(this.dataset.max, 10);
        const oraLimita = parseInt(this.dataset.ora, 10);
        const libere = (this.dataset.libere || '')
          .split(',')
          .map((zi) => zi.trim())
          .filter(Boolean);
        const zi = 86400000;

        // Data și ora curente în România
        const parti = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Bucharest',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          hour12: false,
        }).formatToParts(new Date());
        const valori = Object.fromEntries(parti.map((p) => [p.type, p.value]));
        let expediere = new Date(Date.UTC(Number(valori.year), Number(valori.month) - 1, Number(valori.day)));
        const oraAcum = Number(valori.hour) % 24;

        const lucratoare = (data) => {
          const saptamana = data.getUTCDay();
          return saptamana !== 0 && saptamana !== 6 && !libere.includes(data.toISOString().slice(0, 10));
        };

        // Expediem azi dacă e zi lucrătoare și nu a trecut ora-limită; altfel, în următoarea zi lucrătoare.
        if (!lucratoare(expediere) || oraAcum >= oraLimita) {
          do {
            expediere = new Date(expediere.getTime() + zi);
          } while (!lucratoare(expediere));
        }

        const dupaZile = (start, numar) => {
          let data = start;
          let adaugate = 0;
          while (adaugate < numar) {
            data = new Date(data.getTime() + zi);
            if (lucratoare(data)) adaugate += 1;
          }
          return data;
        };

        const prima = dupaZile(expediere, min);
        const ultima = dupaZile(expediere, Math.max(min, max));
        const numeZi = new Intl.DateTimeFormat('ro-RO', { weekday: 'long', timeZone: 'UTC' });
        const numeLuna = new Intl.DateTimeFormat('ro-RO', { month: 'long', timeZone: 'UTC' });

        let interval;
        if (prima.getTime() === ultima.getTime()) {
          interval = `${numeZi.format(prima)}, ${prima.getUTCDate()} ${numeLuna.format(prima)}`;
        } else if (prima.getUTCMonth() === ultima.getUTCMonth()) {
          interval = `${numeZi.format(prima)}-${numeZi.format(ultima)}, ${prima.getUTCDate()}-${ultima.getUTCDate()} ${numeLuna.format(ultima)}`;
        } else {
          interval = `${numeZi.format(prima)}-${numeZi.format(ultima)}, ${prima.getUTCDate()} ${numeLuna.format(prima)}-${ultima.getUTCDate()} ${numeLuna.format(ultima)}`;
        }

        const ora = String(oraLimita).padStart(2, '0');
        return `${interval}, ${this.dataset.textLimita} ${ora}:00.`;
      }
    }

    customElements.define('rostic-livrare-estimare', RosticLivrareEstimare);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rostic-validare"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rostic-validare')) {
    class RosticValidare extends HTMLElement {
      connectedCallback() {
        this.addEventListener('invalid', this.laInvalid, true);
        this.addEventListener('input', this.laIntroducere);
        this.addEventListener('change', this.laIntroducere);
      }

      disconnectedCallback() {
        this.removeEventListener('invalid', this.laInvalid, true);
        this.removeEventListener('input', this.laIntroducere);
        this.removeEventListener('change', this.laIntroducere);
      }

      laInvalid = (event) => {
        const camp = event.target;
        const esteCamp = camp instanceof HTMLInputElement || camp instanceof HTMLTextAreaElement;
        if (esteCamp && camp.dataset.eroare) camp.setCustomValidity(camp.dataset.eroare);
      };

      laIntroducere = (event) => {
        const camp = event.target;
        if (camp instanceof HTMLInputElement || camp instanceof HTMLTextAreaElement) camp.setCustomValidity('');
      };
    }

    customElements.define('rostic-validare', RosticValidare);
  }
  } catch(e) { console.error(e); }
})();

})();
